import { PowerBIEmbed } from 'powerbi-client-react'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { GET_POWER_BI_TOKEN } from '../../../../graphql/Catalog/PowerBi/powerBi'
import { useQuery } from '@apollo/client'
import { GET_REPORT_POWERBI_BY_PATHNAME } from '../../../../graphql/Catalog/ReportsPowerBI/reportspowerbi'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { models } from 'powerbi-client'
import { isMobile } from 'react-device-detect'

export const ReportPowerBI = () => {
  const history = useHistory()
  //HOOKS
  const [loading, setLoading] = useState(true)
  const [accessToken, setAccessToken] = useState('')
  const [reportPowerBi, setReportPowerBi] = useState(null)

  //QUERY
  const {
    data: dataPowerBiToken,
    loading: loadingPowerBiToken,
    error: errorPowerBiToken,
  } = useQuery(GET_POWER_BI_TOKEN)

  const pathnameModule = '/'+history.location.pathname.split('/').pop()
  const {
    data: dataReportPowerBi,
    loading: loadingReportPowerBi,
    error: errorReportPowerBi,
  } = useQuery(GET_REPORT_POWERBI_BY_PATHNAME, {
    variables: {
      pathnameModule,
    },
    fetchPolicy: 'no-cache',
  })

  //EFFECT
  useEffect(() => {
    if (!loadingPowerBiToken) {
      if (errorPowerBiToken)
        return toastSweetAlert({
          mode: 'error',
          message: 'something has happend',
        })
      //Get Access token
      const token = dataPowerBiToken?.getPowerBiToken?.token
        ? dataPowerBiToken.getPowerBiToken.token
        : null
      setAccessToken(token)
    }
  }, [dataPowerBiToken, loadingPowerBiToken, errorPowerBiToken])

  useEffect(() => {
    try {
      if (loadingReportPowerBi) return
      if (errorReportPowerBi)
        return toastSweetAlert({
          mode: 'error',
          message: errorReportPowerBi.message,
        })

      setReportPowerBi(dataReportPowerBi.getReportPowerBiByPathnameModule)

      setLoading(false)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataReportPowerBi, loadingReportPowerBi, errorReportPowerBi])

  return (
    <>
      {!loading && (
        <div className="row desktop-view">
          <div
            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            id="report-container"
          >
            <PowerBIEmbed
              embedConfig={{
                type: reportPowerBi.type, // Supported types: report, dashboard, tile, visual, and qna.
                id: reportPowerBi.power_bi_id,
                embedUrl: reportPowerBi.embed_url,
                accessToken,
                tokenType: models.TokenType.Aad, // Use models.TokenType.Aad if you're embedding for your organization.
                settings: {
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                    pageNavigation: {
                      visible: false,
                    },
                  },
                  layoutType: isMobile ? models.LayoutType.MobilePortrait : models.LayoutType.Custom, // Adjust layout for mobile
                  navContentPaneEnabled: true, // Enable navigation pane explicitly
                },
              }}
              eventHandlers={
                new Map([
                  [
                    'loaded',
                    function () {
                      console.log('Report loaded')
                    },
                  ],
                  [
                    'rendered',
                    function () {
                      console.log('Report rendered')
                    },
                  ],
                  [
                    'error',
                    function (event) {
                      console.log(event.detail)
                    },
                  ],
                ])
              }
              cssClassName={'embed-container'}
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}
